export const buildStructuredDesktopTable = (data) => {
  const { groups = [], plans = [] } = data;
  const list = [];

  const planItemsMap = new Map();
  plans.forEach((plan) => {
    if (plan.items?.length > 0) {
      plan.items.forEach((planItem) => {
        const uniqueKey = `${plan.name}-${planItem.id}`;
        planItemsMap.set(uniqueKey, planItem);
      });
    }
  });

  groups.forEach((group, groupIndex) => {
    const { header, items = [] } = group;
    const hasItems = items.length > 0;

    const commonGroupProps = {
      isGroupStart: true,
      isGroupEnd: !hasItems,
      groupIndex,
      groupId: header ? header.toLowerCase().replace(/\s+/g, '_') : null
    };

    if (header) {
      const headerRow = {
        items: [
          {
            header,
            valueString: header || '',
            isGroup: true,
            isPlan: false,
            isFirstCell: true,
            ...commonGroupProps
          },
          ...Array.from({ length: plans.length }, (_, index) => ({
            ...commonGroupProps,
            planName: plans[index].name,
            valueString: plans[index]?.value?.value || '',
            id: 'header',
            planId: plans[index].id,
            isGroup: false,
            isPlan: true
          }))
        ]
      };
      list.push(headerRow);
    }

    if (hasItems) {
      items.forEach((item, itemIndex) => {
        const isLastItem = itemIndex === items.length - 1;
        const isFirstItem = itemIndex === 0;
        const commonItemProps = {
          isGroupStart: !header && isFirstItem,
          isGroupEnd: isLastItem,
          isFirstInGroup: isFirstItem,
          isLastInGroup: isLastItem,
          groupIndex,
          groupId: header ? header.toLowerCase().replace(/\s+/g, '_') : null
        };

        const row = {
          items: [
            {
              value: { ...item.name },
              valueString: item?.name?.value || '',
              id: item.id,
              tip: item.tip,
              isFirstCell: true,
              isGroup: true,
              isPlan: false,
              ...commonItemProps
            },
            ...plans.map((plan) => {
              const uniqueKey = `${plan.name}-${item.id}`;
              const planItem = planItemsMap.get(uniqueKey);
              return planItem
                ? {
                    ...planItem,
                    planName: plan.name,
                    valueString: planItem?.value?.value || '',
                    id: item.id,
                    isGroup: false,
                    isPlan: true,
                    planId: plan.id,
                    ...commonItemProps
                  }
                : {
                    planName: plan.name,
                    valueString: planItem?.value?.value || '',
                    id: item.id,
                    isGroup: false,
                    isPlan: true,
                    planId: plan.id,
                    ...commonItemProps
                  };
            })
          ]
        };
        list.push(row);
      });
    }
  });

  return list;
};
